<p-confirmPopup></p-confirmPopup>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div *ngIf="roleName !== userRoles.SUPER_ADMIN " class="card breadcrumbs">
    <div class="common-justify-wrap card-container purple-container">
        <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-0">
            <li class="active-dashboard">
                <a [routerLink]="[roleName === userRoles.SUPER_ADMIN ? '/super-admin/dashboard' : '/manager/dashboard']"
                    class="common-underline">Dashboard</a>
            </li>
            <li class="px-2 breadcrumbs-divider">
                <span>|</span>
            </li>
            <li class="back-link">
                <a [routerLink]="[roleName === userRoles.SUPER_ADMIN ? '/super-admin/parking-list/'+ companyId : '/manager/parking']"
                    class="common-underline">Parking Locations</a>
            </li>
            <li class="px-2 breadcrumbs-divider">
                <span>|</span>
            </li>
            <li class="current-link">
                <span class="line-height-3">Create Parking</span>
            </li>
        </ul>
    </div>
</div>
<div class="main-card">
    <div class="form-deatail">
        <div class="common-flex-between create-active">
            <div class="flex">
                <h3>Create Parking</h3>
            </div>
        </div>
        <form *ngIf="!comingSoonForm" [formGroup]="parkingForm">
            <div class="grid">
                <div class="field col-12 md:col-6 lg:col-4">
                    <div class="custom-flex-start formgrid">
                        <label for="name">Parking Name <span class="custom-star">*</span></label>
                        <input pInputText placeholder="Enter Parking Name" (keydown)="preventFirstSpace($event)"
                            id="name" aria-describedby="name-help" formControlName="name" />
                        <div
                            *ngIf="parkingForm.get('name')?.hasError('required')  && (parkingForm.get('name')?.dirty || parkingForm.get('name')?.touched)">
                            <div class="validation-error"> This field is required*</div>
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-6 lg:col-4">
                    <div class="custom-flex-start formgrid parking-location">
                        <label for="locAddress">Parking Location <span class="custom-star">*</span></label>
                        <div class="p-inputgroup custom-location location-icon">
                            <input id="locAddress" type="text" pInputText placeholder="Set Location on Map"
                                (keydown)="preventFirstSpace($event)" formControlName="locAddress" mapAutoComplete
                                (mapSearch)="searchAutoComplete($event, 'parking')" />
                            <img src="../../../../assets/images/map-location.svg"
                                (click)="openMap(parkingForm, 'locAddress', 'location')" alt="map" />
                        </div>
                        <div
                            *ngIf="parkingForm.get('locAddress')?.hasError('required')  && (parkingForm.get('locAddress')?.dirty || parkingForm.get('locAddress')?.touched)">
                            <div class="validation-error"> This field is required*</div>
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-6 lg:col-4">
                    <div class="custom-flex-start formgrid tax-income">
                        <label for="taxAndFees">Taxes</label>
                        <input id="taxAndFees" pInputText class="common-input" type="text" placeholder="Enter Taxes %"
                            (keypress)="onKeyPressAllowTwoDigitAfterPoint($event)" formControlName="taxAndFees" />
                        <div
                            *ngIf="parkingForm.get('taxAndFees')?.hasError('lessThanHundred') && (parkingForm.get('taxAndFees')?.dirty || parkingForm.get('taxAndFees')?.touched)">
                            <div class="validation-error"> Taxes cannot exceed 100%</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="divider">
            </div>
            <div class="cedtor-outer custom-flex-start formgrid">
                <h5 class="park-heading">Parking Instructions <span class="custom-star">*</span></h5>
                <div class="park-border">
                    <div class=""></div>
                    <div class="one-timebooking">
                        <img src="assets/images/one-time-timer.svg" alt="timer" />
                        <p>One Time Bookings Instruction</p>
                    </div>
                    <div class="booking-textarea">

                        <p-editor #onetime class="oneTimeRecurring-editor" formControlName="oneTimeBookingsInstruction"
                            placeholder="Enter Description"
                            (onTextChange)="oneTimeLimitText($event, onetime, 'oneTimeInstruction')"
                            [style]="{'height':'170px'}" [modules]="editorTools"></p-editor>

                        <div *ngIf="parkingForm.get('oneTimeBookingsInstruction')?.hasError('required')
                            && (parkingForm.get('oneTimeBookingsInstruction')?.dirty || parkingForm.get('oneTimeBookingsInstruction')?.touched)
                            && !oneTimeEditorTextLimitError && !oneTimeEditorSpaceError">
                            <div class="validation-error">This field is required*</div>
                        </div>

                        <div *ngIf="oneTimeEditorSpaceError && !oneTimeEditorTextLimitError">
                            <div class="validation-error">Description cannot be empty or only spaces!</div>
                        </div>

                        <div *ngIf="oneTimeEditorTextLimitError">
                            <div class="validation-error">Character must not exceed 1000.
                            </div>
                        </div>
                    </div>
                    <div class="characters-outer">
                        <p>Characters: {{textLength['oneTimeInstruction'] || 0}}/1000</p>
                    </div>

                    <div class="one-timebooking">
                        <img src="assets/images/one-time-timer.svg" alt="timer" />
                        <p>Recurring Bookings Instructions</p>
                    </div>
                    <div class="booking-textarea">

                        <p-editor #recurring class="oneTimeRecurring-editor"
                            formControlName="recurringBookingsInstruction" placeholder="Enter Description"
                            (onTextChange)="recurringLimitText($event, recurring,'recurringInstruction')"
                            [style]="{'height':'170px'}" [modules]="editorTools"></p-editor>
                        <div *ngIf="parkingForm.get('recurringBookingsInstruction')?.hasError('required')
                            && (parkingForm.get('recurringBookingsInstruction')?.dirty || parkingForm.get('recurringBookingsInstruction')?.touched)
                            && !recurringEditorTextLimitError && !recurringEditorSpaceError">
                            <div class="validation-error">This field is required*</div>
                        </div>

                        <div *ngIf="recurringEditorSpaceError && !recurringEditorTextLimitError">
                            <div class="validation-error">Description cannot be empty or only spaces!</div>
                        </div>

                        <div *ngIf="recurringEditorTextLimitError">
                            <div class="validation-error">Character must not exceed 1000.</div>
                        </div>
                    </div>
                    <div class="characters-outer">
                        <p>Characters: {{textLength['recurringInstruction'] || 0}}/1000</p>
                    </div>
                    <div class="upload-doc">
                        <p>Allow to upload PDF and word format</p>
                        <div class="upload-doc-iiner" (click)="fileInput.click()">
                            <span>Upload Document</span>
                            <img src="assets/images/uploaded-doc.svg" alt="Upload Icon" />
                        </div>
                        <input type="file" accept=".pdf,.docx" #fileInput (change)="onFileSelected($event)" hidden />
                    </div>

                    <div *ngIf="termsAndConditionFilePath" class="doc-close">
                        <a *ngIf="termsAndConditionFilePath" [href]="termsAndConditionFilePath" target="_blank">
                            {{uploadedFile}}
                        </a>
                        <img (click)="removeFile(fileInput)" src="assets/images/close-icon-model.svg"
                            alt="Remove File" />
                    </div>

                </div>
            </div>

            <div class="divider">
            </div>
            <div class="create-access code">
                <h5 class="park-heading">Access Code</h5>
                <div class="access-text">
                    <h5>
                        Access code that the driver needs to use at the time of check-in or re-entry
                    </h5>
                    <p>To use the same code for one-time and monthly bookings, enter the same code</p>
                </div>
                <div class="current-accesscode">
                    <div class="inner-access">
                        <p>Current access code</p>
                        <h4
                            *ngIf="!parkingForm.get('oneTimeAccessCode')?.value && !parkingForm.get('monthlyTimeAccessCode')?.value">
                            System Generated</h4>

                    </div>
                    <div class="one-timemain grid">
                        <div class="col-6">
                            <div class="inner-label">
                                <label for="oneTimeAccessCode">One-time access code</label>
                                <input pInputText placeholder="Enter new access code" maxlength="10"
                                    formControlName="oneTimeAccessCode" (keydown)="preventSpaces($event)" />
                                <div
                                    *ngIf="parkingForm.get('oneTimeAccessCode').hasError('minlength') && !parkingForm.get('oneTimeAccessCode').hasError('pattern')">
                                    <div class="validation-error">Min. 2 character are required.</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="inner-label">
                                <label for="monthlyTimeAccessCode">Monthly access code</label>
                                <input pInputText placeholder="Enter new access code" maxlength="10"
                                    formControlName="monthlyTimeAccessCode" (keydown)="preventSpaces($event)" />
                                <div
                                    *ngIf="parkingForm.get('monthlyTimeAccessCode').hasError('minlength') && !parkingForm.get('monthlyTimeAccessCode').hasError('pattern')">
                                    <div class="validation-error">Min. 2 digits are required.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="divider">
            </div>
            <div class="grid form-deatail">
                <div class="field col-12">
                    <div class="custom-flex-start">
                        <h5 class="park-heading">Amenities</h5>
                        <div class="p-checkbox-row facility-outer">
                            <ul>
                                <li *ngFor="let facilities of facilitiesList"> <p-checkbox name="group1"
                                        (onChange)="addFacilityId(facilities.id)" [value]="facilities.facilityName"
                                        [inputId]="facilities.id">
                                    </p-checkbox>
                                    <label for="facilityName">{{ facilities.facilityName }}</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="divider">
            </div>
            <div formArrayName="truckTypeArray">
                <div *ngFor="let truckGroup of truckTypeArray.controls; let i = index" [formGroupName]="i"
                    class="half-length">
                    <div class="spot-outer">
                        <div class="half-text">
                            <h4>Spot Type - <span *ngIf="spotTypes[i]?.categoryName .includes('Full-Length')">Full
                                    Length</span>
                                <span *ngIf="!spotTypes[i]?.categoryName.includes('Full-Length')">Half Length</span>
                            </h4>
                            <app-tooltip [tooltipMessage]="spotTypes[i]?.description"
                                [addClass]="'custom-tooltip-width'"></app-tooltip>
                        </div>

                        <div class="add-special add-morebtn rate-outer">
                            <p class="regular-rate">To add a special rate, you must first add a regular rate.</p>
                            <p-button label="Add Special Rate" icon="pi pi-plus" [disabled]="isSpecialRateEnabled(i)"
                                (onClick)="openCustomRates(spotTypes[i]?.id)" iconPos="right">
                            </p-button>
                        </div>
                    </div>

                    <div class="public-rate">
                        <div class="grid public-padding">
                            <div class="custom-flex-start md:col-3 custom-spacing-lright">
                                <label for="dailyRate-{{ i }}">Daily Public Rate <span
                                        class="custom-star">*</span></label>
                                <input pInputText inputmode="decimal"
                                    (keypress)="onKeyPressAllowTwoDigitAfterPoint($event)" id="dailyRate-{{ i }}"
                                    aria-describedby="dailyRate-help" placeholder="Enter Daily Charges"
                                    formControlName="dailyRate" maxlength="8" />
                                <div *ngIf="truckGroup.get('dailyRate')?.dirty || truckGroup.get('dailyRate')?.touched">
                                    <div *ngIf="truckGroup.get('dailyRate')?.hasError('required')"
                                        class="validation-error">
                                        This field is required*
                                    </div>
                                    <div *ngIf="truckGroup.get('dailyRate')?.hasError('lessThanZero') && !truckGroup.get('dailyRate')?.hasError('required')"
                                        class="validation-error">
                                        Charge must be greater than 0*
                                    </div>
                                </div>
                            </div>
                            <div class="custom-flex-start md:col-3 custom-spacing-lright">
                                <label for="monthlyRate-{{ i }}">Monthly Public Rate <span
                                        class="custom-star">*</span></label>
                                <input pInputText inputmode="decimal"
                                    (keypress)="onKeyPressAllowTwoDigitAfterPoint($event)" id="monthlyRate-{{ i }}"
                                    aria-describedby="monthlyRate-help" placeholder="Enter Monthly Charges"
                                    formControlName="monthlyRate" maxlength="8" />
                                <div
                                    *ngIf="truckGroup.get('monthlyRate')?.dirty || truckGroup.get('monthlyRate')?.touched">
                                    <div *ngIf="truckGroup.get('monthlyRate')?.hasError('required')"
                                        class="validation-error">
                                        This field is required*
                                    </div>
                                    <div *ngIf="truckGroup.get('monthlyRate')?.hasError('lessThanZero') && !truckGroup.get('monthlyRate')?.hasError('required')"
                                        class="validation-error">
                                        Charge must be greater than 0*
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="getRatesBySpotTypeId(spotTypes[i]?.id)?.length > 0" class="half-table">
                            <p-table [value]="getRatesBySpotTypeId(spotTypes[i]?.id)" responsiveLayout="scroll">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th scope="col">Code</th>
                                        <th scope="col">Daily Rate ($)</th>
                                        <th scope="col">Monthly Rate ($)</th>
                                        <th scope="col" class="custom-description">Description</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-record>
                                    <tr>
                                        <td>
                                            <p class="common-style">{{ record.code }}</p>
                                        </td>
                                        <td>
                                            <p class="common-style">{{ record.dailyRate }}</p>
                                        </td>
                                        <td>
                                            <p class="common-style">{{ record.monthlyRate }}</p>
                                        </td>
                                        <td>
                                            <div class="long-description">
                                                <app-tooltip [tooltipMessage]="record.description"></app-tooltip>
                                                <p class="common-style">{{ record.description }}</p>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="three-dot">
                                                <img (click)="activeItem = record; showData(record,$event); menu.toggle($event);"
                                                    src="assets/images/dashboard-dot.svg" alt="" />
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-deatail">
                <div class="divider">
                </div>
                <div class="upload-outer">
                    <label>Upload Parking Photo</label>
                    <div class="grid">
                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="add-image">
                                <p-fileUpload #fileUpload mode="basic" name="demo[]"
                                    (onSelect)="uploadImage1($event.files)" [auto]="true"
                                    chooseLabel="Add Image"></p-fileUpload>
                                <div *ngIf="btn1" class="img-overlap"
                                    [style.background-image]="'url(' + imageUrl1 + ')'">
                                    <ul>
                                        <li>
                                            <img src="assets/images/img-delete.svg" alt="" (click)="del1(imageUrl1)" />
                                        </li>
                                        <li>
                                            <img src="assets/images/img-view.svg" alt=""
                                                (click)="showDialog(imageUrl1)" />
                                        </li>
                                    </ul>
                                </div>
                                <div *ngIf="isImgError1">
                                    <div class="validation-error">File size should be less than 5MB.</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="add-image">
                                <p-fileUpload #fileUpload1 mode="basic" name="demo[]" (onSelect)="uploadImage2($event)"
                                    [auto]="true" chooseLabel="Add Image"></p-fileUpload>
                                <div *ngIf="btn2" class="img-overlap"
                                    [style.background-image]="'url(' + imageUrl2 + ')'">
                                    <ul>
                                        <li>
                                            <img src="assets/images/img-delete.svg" alt="" (click)="del2(imageUrl2)" />
                                        </li>
                                        <li>
                                            <img src="assets/images/img-view.svg" alt=""
                                                (click)="showDialog(imageUrl2)" />
                                        </li>
                                    </ul>
                                </div>
                                <div *ngIf="isImgError2">
                                    <div class="validation-error">File size should be less than 5MB.</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="add-image">
                                <p-fileUpload #fileUpload2 mode="basic" name="demo[]" (onSelect)="uploadImage3($event)"
                                    [auto]="true" chooseLabel="Add Image"></p-fileUpload>
                                <div *ngIf="btn3" class="img-overlap"
                                    [style.background-image]="'url(' + imageUrl3 + ')'">
                                    <ul>
                                        <li>
                                            <img src="assets/images/img-delete.svg" alt="" (click)="del3(imageUrl3)" />
                                        </li>
                                        <li>
                                            <img src="assets/images/img-view.svg" alt=""
                                                (click)="showDialog(imageUrl3)" />
                                        </li>
                                    </ul>
                                </div>
                                <div *ngIf="isImgError3">
                                    <div class="validation-error">File size should be less than 5MB.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid next-btn">
                <p-button label="Next" (onClick)="nextPage(parkingForm)" class="ml-auto"></p-button>
            </div>
        </form>
        <form class="upcoming-soon" *ngIf="comingSoonForm" [formGroup]="parkingUpcomingForm">
            <div class="grid">
                <div class="field col-12 md:col-6 lg:col-6 custom-spacing-right pb-0">
                    <div class="custom-flex-start formgrid">
                        <label for="parkingName">Parking Name <span class="custom-star">*</span></label>
                        <input pInputText placeholder="Type Parking Name" id="parkingName"
                            (keydown)="preventFirstSpace($event)" aria-describedby="parkingName-help"
                            formControlName="parkingName" />
                        <div
                            *ngIf="parkingUpcomingForm.get('parkingName')?.hasError('required')  && (parkingUpcomingForm.get('parkingName')?.dirty || parkingUpcomingForm.get('parkingName')?.touched)">
                            <div class="validation-error"> This field is required*</div>
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-6 lg:col-6 custom-spacing-lright pb-0">
                    <div class="custom-flex-start formgrid parking-location">
                        <label for="parkingLocation">Parking Location<span class="custom-star">*</span></label>
                        <div class="p-inputgroup custom-location">
                            <input type="text" pInputText placeholder="Set Location on Map"
                                (keydown)="preventFirstSpace($event)" formControlName="parkingLocation" mapAutoComplete
                                (mapSearch)="searchAutoComplete($event, 'parkingUpcoming')" />
                            <img src="../../../../assets/images/map-location.svg"
                                (click)="openMap(parkingUpcomingForm, 'parkingLocation', 'location')" alt="map" />
                        </div>
                        <div
                            *ngIf="parkingUpcomingForm.get('parkingLocation')?.hasError('required')  && (parkingUpcomingForm.get('parkingLocation')?.dirty || parkingUpcomingForm.get('parkingLocation')?.touched)">
                            <div class="validation-error"> This field is required*</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid next-btn">
                <p-button label="Save" (onClick)="save(parkingUpcomingForm)" class="ml-auto"></p-button>
            </div>
        </form>
    </div>
</div>
<div class="img-pre custom-preimg upload-model" *ngIf="imagePreview">
    <p-dialog header="Header" [(visible)]="visible" [modal]="true" [style]="{ width: '75vw' }" [draggable]="false"
        [resizable]="false" (click)="onDialogHide()">
        <div class="image-cross">
            <img src="assets/images/export-close.svg" alt="">
        </div>

        <img [src]="imageLinkForPreview" class="preview-image" alt="preview" />

    </p-dialog>
</div>
<div class="custom-export"> <p-menu #menu [model]="items" [popup]="true"></p-menu>
</div>